import Layout from "../../components/layouts/layout.comp";
import MailTemplateEditor from "../../components/mailTemplate/mailTemplateEditor";
import { EditingMode } from "../../components/reuseables/form.comp";
import { useTranslation } from "../../core/translation.core";

export default function MailTemplateCreatePage() {
  const { t, msg } = useTranslation();

  return (
    <Layout title={t(msg.mailTemplate.mailTemplate)}>
      <MailTemplateEditor editingMode={EditingMode.create} />
    </Layout>
  );
}
